import Vue from 'vue';

function addClass(dom, className) {
  dom.classList.add('wow', className);
}

function addDuration(dom, time) {
  dom.setAttribute('data-wow-duration', time);
}

function addDelay(dom, time) {
  dom.setAttribute('data-wow-delay', time);
}

function addOffset(dom, offset) {
  dom.setAttribute('data-wow-offset', offset);
}
//最多有四个子元素，最后一个子元素使用keyVisionMotion动画
function addTextMotionAttr(el, binding) {
  let baseOffset = binding.value;
  let allDoms = Array.from(el.children);
  let [titleDom, subTitleDom, descriptionDom, otherDom] = allDoms;
  if (!titleDom) return;
  let normalTextDoms = allDoms.slice(0, 3).filter(dom => dom);
  let titleHeight = titleDom.clientHeight;
  let subTitleHeight, descriptionHeight;
  const availHeight = screen.availWidth <= 734 ? 100 : screen.availHeight / 2;
  normalTextDoms.forEach(dom => {
    addClass(dom, 'textInPartMotion');
    addDuration(dom, '0.4s');
  });
  addDelay(titleDom, '0.15s');
  if (baseOffset) {
    addOffset(titleDom, baseOffset);
  } else if (screen.availWidth <= 734) {
    addOffset(titleDom, availHeight);
  }
  if (subTitleDom) {
    addDelay(subTitleDom, '0.4s');
    addOffset(subTitleDom, (baseOffset || availHeight) - titleHeight);
  }
  if (descriptionDom) {
    subTitleHeight = titleHeight + subTitleDom.clientHeight;
    addDelay(descriptionDom, '0.5s');
    addOffset(descriptionDom, (baseOffset || availHeight) - subTitleHeight);
  }
  if (otherDom) {
    addClass(otherDom, 'keyVisionMotion');
    addDuration(otherDom, '0.4s');
    addDelay(otherDom, '0.5s');
    descriptionHeight = subTitleHeight + descriptionDom.clientHeight;
    addOffset(otherDom, (baseOffset || availHeight) - descriptionHeight);
  }
}
Vue.directive('textMotion', {
  inserted(el, binding) {
    addTextMotionAttr(el, binding);
  }
});

Vue.directive('bannerTextMotion', {
  inserted(el) {
    let bannerHeight = el.clientHeight;
    let textDom = el.querySelector('.part-banner-left');
    let keyDom = el.querySelector('.part-banner-right');
    let deltaHeight = (bannerHeight - textDom.clientHeight) / 2 - (bannerHeight - keyDom.clientHeight) / 2;
    addClass(keyDom, 'keyVisionMotion');
    addDuration(keyDom, '0.3s');
    addTextMotionAttr(textDom, {
      value: screen.availHeight / 2 - deltaHeight
    });
  }
});
